import React, { Component } from 'react'

class NotFound extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div id="NotFound">
        <h1>404</h1>
        <p>Ooops, we have not found anything here. Please proceed to our <a href="/">home page</a></p>
      </div>
    );
  }
}

export default NotFound


// WEBPACK FOOTER //
// ./src/components/NotFound.jsx